import { render, staticRenderFns } from "./PartnerPlanForm.vue?vue&type=template&id=080235c4&scoped=true"
import script from "./PartnerPlanForm.vue?vue&type=script&lang=js"
export * from "./PartnerPlanForm.vue?vue&type=script&lang=js"
import style0 from "./PartnerPlanForm.vue?vue&type=style&index=0&id=080235c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080235c4",
  null
  
)

export default component.exports